import { render } from "./FormFileSelect.vue?vue&type=template&id=f0f476ca&scoped=true"
import script from "./FormFileSelect.vue?vue&type=script&lang=js"
export * from "./FormFileSelect.vue?vue&type=script&lang=js"

import "./FormFileSelect.vue?vue&type=style&index=0&id=f0f476ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f476ca"]])

export default __exports__